import { gql } from '@apollo/client';
export const query = gql `
  query GetDocumentMetadata($documentId: ID!) {
    properties: documentMetadataProperties(orderBy: [{ order: asc }]) {
      id
      name
      type
      isMultiSelect
      reference
    }

    pairs: documentMetadataPairs(where: { documentId: { eq: $documentId } }) {
      id
      value
      lastSetBy
      approvedByUserId
      property {
        id
        name
      }
    }

    systemData: fileSystemDocument(id: $documentId) {
      id
      createdAt
      updatedAt
      name

      user {
        id
        name
      }

      lastSignRequest {
        id
        signedAt: signed_at
      }

      category {
        id
        metadata {
          id
          title
          marketLocaleCode: market_locale_code
        }
      }

      template: unstable__template {
        id
        composerTemplates {
          id
          composer {
            id
            metadata {
              name
              marketLocaleCode
            }
          }
        }
      }
    }

    companies {
      documentMetadataFeatures {
        id
        companyId
        feature
      }
    }
  }
`;
